import { ArrayMapper } from "../../../../../../harmony/core";
import { MediaEntityToMediaMapper } from "../../../../../features/media/domain/mappers/media.mapper";
import { RecommendedScheduleEntityToRecommendedScheduleMapper } from "../../../../../features/media/domain/mappers/recommended-schedules.mapper";
import { ImageMedia } from "../../../../../features/media/domain/models/media";
import { InstagramCarouselEntity } from "../../data/entities/instagram-carousel.entity";
import { InstagramSingleImageEntity } from "../../data/entities/instagram-single-image.entity";
import { InstagramStoryEntity } from "../../data/entities/instagram-story.entity";
import { InstagramCarousel } from "../models/instagram-carousel";
import { InstagramSingleImage } from "../models/instagram-single-image";
import { InstagramStory } from "../models/instagram-story";

export const mapInstagramStoryEntityToModel = (
  from: InstagramStoryEntity,
): InstagramStory => {
  const mediaMapper = new MediaEntityToMediaMapper();
  const schedulesMapper = new ArrayMapper(
    new RecommendedScheduleEntityToRecommendedScheduleMapper(),
  );

  return new InstagramStory(
    from.id,
    mediaMapper.map(from.media),
    from.recommendedSchedules
      ? schedulesMapper
          .map(from.recommendedSchedules)
          .sort((a, b) => a.startDate.getTime() - b.startDate.getTime())
      : [],
  );
};

export const mapInstagramSingleImageEntityToModel = (
  from: InstagramSingleImageEntity,
): InstagramSingleImage => {
  const schedulesMapper = new ArrayMapper(
    new RecommendedScheduleEntityToRecommendedScheduleMapper(),
  );
  const mediaMapper = new MediaEntityToMediaMapper();

  return new InstagramSingleImage(
    from.id,
    from.text,
    mediaMapper.map(from.image) as ImageMedia,
    from.recommendedSchedules
      ? schedulesMapper
          .map(from.recommendedSchedules)
          .sort((a, b) => a.startDate.getTime() - b.startDate.getTime())
      : [],
  );
};

export const mapInstagramCarouselEntityToModel = (
  from: InstagramCarouselEntity,
): InstagramCarousel => {
  const schedulesMapper = new ArrayMapper(
    new RecommendedScheduleEntityToRecommendedScheduleMapper(),
  );
  const mediaMapper = new MediaEntityToMediaMapper();

  return new InstagramCarousel(
    from.id,
    from.text,
    from.media.map((item) => mediaMapper.map(item)),
    from.recommendedSchedules
      ? schedulesMapper
          .map(from.recommendedSchedules)
          .sort((a, b) => a.startDate.getTime() - b.startDate.getTime())
      : [],
  );
};
